import { DropdownLayout } from '../components';
import type { StyleProps } from './types';

export function Style12({ items, onClick }: StyleProps) {
  return (
    <DropdownLayout
      items={items}
      withFlag
      flagStyle="rounded"
      activeItemNameKey="originalName"
      onClick={onClick}
    />
  );
}
